import React from 'react';

export default function Input({ value, onChange, placeholder, ...props }) {
  return (
    <input
      type="text"
      className="w-full p-2 border border-gray-300 rounded"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      {...props}
    />
  );
}